import { useTracking } from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';

import { CompanyIcon } from '@/components/CompanyIcon';
import { memo } from 'react';

interface Props {
  websiteUrl: string | null | undefined;
  tickerSymbol: string;
  name: string;
  canonicalURL: string;
}

const CompanyNameWithIconBase = ({
  canonicalURL,
  websiteUrl,
  tickerSymbol,
  name,
}: Props) => {
  const { trackEvent } = useTracking();

  return (
    <RouterLink
      noUnderline
      to={canonicalURL}
      onClick={() => {
        trackEvent({
          action: 'click',
          canonicalURL,
        });
      }}
    >
      <div className="grid grid-cols-[max-content_auto] gap-x0_5">
        <CompanyIcon
          website={websiteUrl}
          tickerSymbol={tickerSymbol}
          size={34}
        />
        <div className="ml-1 grid gap-0.5">
          <div className="flex items-center gap-x1 text-xs font-strong text-brand-01">
            {tickerSymbol}
            <div className="line-clamp-1 text-tiny text-softer">{name}</div>
          </div>
        </div>
      </div>
    </RouterLink>
  );
};

export const CompanyNameWithIcon = memo(CompanyNameWithIconBase);
